import { useMemo } from 'react'

import useSiteMetadata from '../../../hooks/useSiteMetadata'
import { AddressRestrictions } from '../types'

const caShippingRestrictions: AddressRestrictions = {
  isAddressAllowed: (address) => address?.country_code !== 'US',
  isCartAddressAllowed: (address) => address?.country?.code !== 'US',
  isCountryOptionAllowed: (option) => option.value !== 'US',
}

const defaultRestrictions: AddressRestrictions = {
  isAddressAllowed: () => true,
  isCartAddressAllowed: () => true,
  isCountryOptionAllowed: () => true,
}

function useShippingRestrictions(): AddressRestrictions {
  const { shippingRestrictions } = useSiteMetadata() ?? {}

  return useMemo(
    () => (shippingRestrictions === 'CA' ? caShippingRestrictions : defaultRestrictions),
    [shippingRestrictions],
  )
}

export default useShippingRestrictions
